/*
 *
 * RegAttemptsExceededModal
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 08-Oct-2024
*/

import RegAttemptsExceededModal from './RegAttemptsExceededModalContainer'

export default RegAttemptsExceededModal
